import {
  FETCH_ENTITY_RELATIONS_BEGIN,
  FETCH_ENTITY_RELATIONS_SUCCESS,
  FETCH_ENTITY_RELATIONS_FAILURE,
  FETCH_USER_RELATIONS_SUCCESS,
} from "../types";

const initialState = {
  entityRelations: [],
  loading: false,
  error: null,
};

const userState = {
  userRelations: [],
  loading: false,
  error: null,
};

export function entityRelations(state = initialState, action) {
  switch (action.type) {
    case FETCH_ENTITY_RELATIONS_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_ENTITY_RELATIONS_SUCCESS:
      // All done: set loading "false".
      // Also, replace the entityRelations with the ones from the server
      return {
        ...state,
        loading: false,
        entityRelations: action.data,
      };

    case FETCH_ENTITY_RELATIONS_FAILURE:
      // The request failed. It's done. So set loading to "false".
      // Save the error, so we can display it somewhere.
      // Since it failed, we don't have  entityRelations to display anymore, so set `entityRelations` empty.
      //
      // This is all up to you and your app though:
      // maybe you want to keep the  entityRelations around!
      // Do whatever seems right for your use case.
      return {
        ...state,
        loading: false,
        error: action.error,
        entityRelations: [],
      };
    default:
      return state;
  }
}

export function userRelations(state = userState, action) {
  switch (action.type) {
    // case FETCH_ENTITY_RELATIONS_BEGIN:
    //   // Mark the state as "loading" so we can show a spinner or something
    //   // Also, reset any errors. We're starting fresh.
    //   return {
    //     ...state,
    //     loading: true,
    //     error: null
    //   };

    case FETCH_USER_RELATIONS_SUCCESS:
      // console.log(action.data, "action.data");
      // All done: set loading "false".
      // Also, replace the entityRelations with the ones from the server
      return {
        ...state,
        loading: false,
        userRelations: action.data,
      };

    // case FETCH_ENTITY_RELATIONS_FAILURE:
    //   // The request failed. It's done. So set loading to "false".
    //   // Save the error, so we can display it somewhere.
    //   // Since it failed, we don't have  entityRelations to display anymore, so set `entityRelations` empty.
    //   //
    //   // This is all up to you and your app though:
    //   // maybe you want to keep the  entityRelations around!
    //   // Do whatever seems right for your use case.
    //   return {
    //     ...state,
    //     loading: false,
    //     error: action.error,
    //     entityRelations: []
    //   };
    default:
      return state;
  }
}
